import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useDirection } from '../hooks/useDirection.js';

/**
 * Shown when the SPA loads on a host that is NOT the platform host and is not a
 * known/verified tenant domain. Mirrors StorefrontLayout's not-found branch.
 */
export function DomainNotConfiguredPage(): JSX.Element {
  const { t } = useTranslation();
  const dir = useDirection();
  return (
    <div className="grid min-h-screen place-items-center bg-bg px-6 text-center text-fg" dir={dir}>
      <div>
        <Globe className="mx-auto h-10 w-10 text-fg-subtle" aria-hidden />
        <h1 className="mt-3 text-xl font-semibold">
          {t('domainNotConfigured.title', { defaultValue: 'Domain not configured' })}
        </h1>
        <p className="mt-1 text-sm text-fg-muted">
          {t('domainNotConfigured.hint', {
            defaultValue:
              'This domain is not connected to a workspace yet. If you just set it up, DNS and verification can take a few minutes.',
          })}
        </p>
      </div>
    </div>
  );
}
